import 'slick-carousel';
import { Component } from 'js-component-framework';

/**
 * Component for instantiating Jumbotron Carousel.
 * @todo: confirm need for adding onresize changes to carousel settings
 */
export default class JumbotronCarousel extends Component {

  /**
   * Determine mobile viewport
   */
  static isMobile() {
    return matchMedia('only screen and (max-width: 768px)').matches;
  }

  /**
   * Start the component
   */
  constructor(config) {
    super(config);

    // Initalizations
    if (! this.constructor.isMobile()) {
      this.setCarousel();
      this.setTriggers();
    }
  }

  /**
   * Set Carousel
   * @see http://kenwheeler.github.io/slick/
   */
  setCarousel() {
    $(this.options.carouselClass).slick(this.options.slick);
  }

  /**
   * Set Slide Triggers.
   */
  setTriggers() {
    Array.prototype.forEach.call(this.children.articles, (article, index) => {
      article.addEventListener('click', (event) => {
        if (window.matchMedia('(min-width: 768px)').matches) {
          event.preventDefault();
          this.setActiveSlide(article, index);
        }
      });
    });
  }

  /**
   * Set a slide to active state.
   * @param {HTML element} slide slide to become active
   * @param {Integer} index index of slide to become active
   */
  setActiveSlide(slide, index) {
    this.removeActiveSlide();
    slide.classList.add(this.options.activeSlideClass);
    $(this.options.carouselClass).slick('slickGoTo', index);
  }

  /**
   * Remove active state from all slides.
   */
  removeActiveSlide() {
    Array.prototype.forEach.call(this.children.articles, (article) => {
      if (article.classList.contains(this.options.activeSlideClass)) {
        article.classList.remove(this.options.activeSlideClass);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./client/js/components/JumbotronCarousel/JumbotronCarousel.js